<template>
  <div class="home py-5">
    <span class="d-flex flex-row page-title">{{$t("intranet.title.page.invoices")}}</span>
    <div v-if="dataLoaded" class="sheet-container">
      <div class="d-flex flex-xl-row flex-lg-row flex-column justify-start mt-4 mr-xl-16 mr-lg-12">
        <v-select
          class="ma-6"
          v-model="payedFilter"
          :items="[{text:$t(`aveine-invoice.title.all`), value:null},
                    {text:$t(`aveine-invoice.title.payed`), value:true},
                    {text:$t(`aveine-invoice.title.notPayed`), value:false}]"
          :label="$t('aveine-invoice.title.paymentFilter')"
        ></v-select>
        <v-select
          class="ma-6"
          v-model="sortInvoice"
          :items="[{text:$t(`aveine-invoice.title.desc`), value:'desc'},
                  {text:$t(`aveine-invoice.title.asc`), value:'asc'}]"
          :label="$t('aveine-invoice.title.sort')"
        ></v-select>
      </div>
      <AveineInvoiceManagement :APIbaseURL="APIbaseURL" :invoices="invoices" :adminMode="true"/>
      <div class="text-center">
        <v-pagination
          v-model="currentPage"
          :length="paginationLength"
          :total-visible="paginationLength < 7 ? paginationLength : 7"
        ></v-pagination>
      </div>
    </div>
    <div v-else class="d-flex justify-center align-center mt-16">
      <v-progress-circular
        indeterminate
        :size="100"
        :width="10"
        color="secondary"
      ></v-progress-circular>
    </div>
  </div>
</template>

<script>
import { AveineInvoiceManagement } from 'aveine-invoice';
import { Invoice } from 'aveine-toolbox';
import { errorHandler } from 'aveine-toolbox'
export default {
  data () {
    return {
      invoices: [],
      payedFilter: null,
      sortInvoice: "desc",
      currentPage: this.$route.query.page ? parseInt(this.$route.query.page) : 1,
      paginationLength: 0,
      dataLoaded: false,
      APIbaseURL: process.env.VUE_APP_API_HOST
    }
  },
  name: 'Invoice',
  components: {
    AveineInvoiceManagement
  },

  watch: {
    payedFilter () {
      this.loadInvoices();
    },
    sortInvoice () {
      this.loadInvoices()
    },
    async currentPage (val) {
      this.dataLoaded= false;
      this.$router.push({ path: '/authenticated/invoices', query: { page: val }});
    },
  },
  
  async mounted() {
    this.loadInvoices();
  },
  methods: {
    async loadInvoices () {
      try {
        this.invoices = [];
        this.dataLoaded = false;
        
        let params =  
        {
          "page[number]": this.$route.query.page || 1,
          "page[size]": 40,
          "include": 'ambassador.user, super-ambassador.user'
        };

        if (this.payedFilter == true) 
          params[`filter[paid-at][NE]`] = "null"
        else if (this.payedFilter == false)
          params[`filter[paid-at]`] = "null"

        if (this.sortInvoice == "desc")
          params[`sort`] = "-created-at"
        else if  (this.sortInvoice == "asc")
          params[`sort`] = "created-at"


        let invoices = await Invoice.api().get(`invoices?lang=${this.$i18n.locale}`, {
            params
          }
        );

        const that = this;
        invoices.response.data.map(async function(data){
          that.invoices.push(await Invoice.query().whereId(data.id).withAllRecursive().first());
        })
        this.paginationLength = invoices.response.data.meta.last
        this.dataLoaded = true;
      } catch (errors) {
        this.dataLoaded = true;
        errorHandler(errors, this)
      }
    }
  }
}
</script>
